import ReadOrEdit from './ReadOrEdit';

export default ReadOrEdit;
